import { realUe, teilnahmeEnde, spanWochen, formatWochen } from './teilnahmeEnde'

export function buildUeCapNote(
  massnahmeUe: number,
  maxUe: number,
): { label: string; hint: string } | null {
  const real = realUe(massnahmeUe, maxUe)
  if (real >= massnahmeUe) return null
  return {
    label: `(${real} von ${massnahmeUe} UE lt. AVGS)`,
    hint: `Der AVGS-Gutschein begrenzt diese Maßnahme auf ${real} von ${massnahmeUe} UE.`,
  }
}

export function endeCapOverride(
  beginnIso: string,
  endeIso: string,
  wochen: number | null,
  maxEnde: string | null,
): { tone: 'warning'; text: string } | null {
  if (wochen == null || !maxEnde) return null
  const calcEnde = teilnahmeEnde(beginnIso, wochen)
  if (!calcEnde || !(maxEnde < calcEnde)) return null
  const shownSpan = spanWochen(beginnIso, endeIso)
  const cappedSpan = spanWochen(beginnIso, maxEnde)
  if (shownSpan == null || cappedSpan == null || shownSpan !== cappedSpan) return null
  return {
    tone: 'warning',
    text: `${formatWochen(cappedSpan)} — durch AVGS begrenzt (rechnerisch ${formatWochen(wochen)})`,
  }
}
